import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HttpClientService {
    constructor(private http: HttpClient) {
    }

    get<T>(url: string): Observable<T> {
        const observable = this.http.get<T>(environment.apiUrl + url);
        // Leaving this here for debug purposes in the future
        // observable.subscribe(x => {
        //   console.log(url);
        //   // this.apiCalls[url] = x;
        //   // this.createLink();
        // });
        return observable;
    }

    post<T, R>(body: T, url: string, headers?: HttpHeaders): Observable<R> {
        const observable = this.http.post<R>(environment.apiUrl + url, body, {headers});
        return observable;
    }

    put<T, R>(body: T, url: string): Observable<R> {
        return this.http.put<R>(environment.apiUrl + url, body);
    }

    delete<T, R>(body: T, url: string): Observable<R> {
        return this.http.delete<R>(environment.apiUrl + url, body);
    }
}
